import React, {useEffect, useState} from 'react';

export function InputDate({className = '', value, handleChange, placeholder, name}) {
  const [date, setDate] = useState(value || '');

  useEffect(() => {
    if (date === value) {
      return;
    }

    handleChange(name, date)
  }, [date, value, handleChange]);

  return <React.Fragment>
    <span>
      <span>{placeholder}</span>
    <input className={"input" + (className ? " " + className : "")}
           placeholder={placeholder}
           name={name}
           value={date}
           type="date"
           onChange={(e) => setDate(e.target.value)} /></span>
  </React.Fragment>;
}
